const Wifi02Icon = /*#__PURE__*/ [
  ["path", { d: "M12 18.5H12.0118", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", key: "0" }],
  ["path", { d: "M8.25 15.5C10.25 13.5 13.75 13.5 15.75 15.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M18.5 12.5C14.7324 9.16667 9.5 9.16667 5.5 12.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M2 9.5C8.31579 4.16669 15.6842 4.16668 22 9.49989", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export { Wifi02Icon as default };
//# sourceMappingURL=Wifi02Icon.js.map
